<div *ngIf="!isSub" class="heading">
  <h3 [id]="id" [title]="title">{{title}}</h3>
</div>
<div *ngIf="isSub" class="sub-heading">
  <h4 [id]="id" [title]="title">{{title}}</h4>
</div>

